/* EDELHOLZ: Sondermass-/Sonderfinish-Zuschlaege haengen an ihrem Tisch (25.09.26, Querpruefung Nr. 2).
   Konfigurator B und Kaufbox geben Tisch und Zuschlaegen dieselbe versteckte Property _eh_konfig.
   Aendert der Kunde die Menge eines solchen Tisches (Entfernen-Link, Minus/Plus, Mengenfeld) auf der
   Warenkorbseite oder im Drawer, gehen seine Zuschlaege mit: Menge 0 = weg, sonst Schritte je Tisch
   mal neue Tischmenge. Alles in EINEM /cart/update.js-Aufruf.
   Einhaengen: Capture-Listener vor dem Prestige-Element line-item-quantity (assets/theme.dev.js,
   changeLineItemQuantity_fn). Nur Zeilen mit data-eh-konfig (main-cart.liquid, snippets/line-item.liquid)
   werden abgefangen; bei jedem Fehler laeuft die Aenderung wie bei Prestige ueber /cart/change.
   05.10.26 (D392): Seit assets/edelholz-tisch-zuordnung.js tragen auch die Add-ons eines Tisches seine _eh_konfig.
   Sie gehen jetzt genauso mit (Entfernen = weg, Menge = Vielfaches). Aendert sich die Menge eines Add-ons
   oder Zuschlags selbst, bleibt alles andere unberuehrt.
   05.10.26: Geht ein Add-on einer Tischgruppe auf 0 (Unterzeile "entfernen", snippets/eh-cart-unterzeilen.liquid traegt
   dafuer data-eh-konfig), wird es danach auch aus "Add-ons"/_eh_addons des Tisches ausgetragen
   (window.EHTisch.addonAustragen, assets/edelholz-tisch-zuordnung.js). Erst entfernen, dann austragen: scheitert das
   Austragen, ist das Add-on trotzdem weg. Der Tisch bekommt dabei einen neuen Key, darum zeichnet der Drawer mit der
   Antwort des Austragens neu, die Warenkorbseite laedt neu. */
(function () {
  if (window.__ehZuschlagKopplung) return;
  window.__ehZuschlagKopplung = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var laeuft = false;

  var TISCH = ['design-schreibtisch-holz', 'deskpro-schreibtisch-mit-schublade-holz', 'arcpure-eckschreibtisch-massivholz'];
  /* wie snippets/eh-zuschlag-waise.liquid (Handle oder _eh_gruppe 'tisch'), dazu Modell-Property */
  function istTisch(it) {
    var p = (it && it.properties) || {};
    if (!it) return false;
    if (TISCH.indexOf(it.handle) > -1 || p._eh_gruppe === 'tisch') return true;
    try { return !!(window.EHTisch && window.EHTisch.istTisch(it)); } catch (e) { return false; }
  }
  function istWarenkorbSeite() {
    try { return window.themeVariables.settings.pageType === 'cart'; } catch (e) { return location.pathname.replace(/\/$/, '').slice(-5) === '/cart'; }
  }
  function perSeite(key, menge) {
    window.location.href = root + 'cart/change?id=' + encodeURIComponent(key) + '&quantity=' + menge;
  }

  /* Add-on aus der Liste des Tisches austragen. Liefert die Antwort von /cart/change.js oder null, wirft nie.
     Nach 6 s ohne Antwort null; kommt sie spaeter doch, holt cart:refresh den Drawer mit dem neuen Tisch-Key. */
  function austragen(vorher, key, sections) {
    if (!vorher) return Promise.resolve(null);
    var fertig = false;
    var lauf;
    try { lauf = window.EHTisch && window.EHTisch.addonAustragen ? window.EHTisch.addonAustragen(vorher, key, sections) : null; } catch (e) { lauf = null; }
    if (!lauf || typeof lauf.then !== 'function') return Promise.resolve(null);
    lauf = lauf.catch(function () { return null; });
    lauf.then(function (j) {
      if (fertig && j && !istWarenkorbSeite()) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
    var uhr;
    var zeit = new Promise(function (ok) { uhr = setTimeout(function () { ok(null); }, 6000); });
    return Promise.race([lauf, zeit]).then(function (j) { clearTimeout(uhr); fertig = true; return j; });
  }

  async function aendern(el, key, menge) {
    var konfig = el.getAttribute('data-eh-konfig');
    var updates = {};
    updates[key] = menge;
    var vorher = null; /* Warenkorb vor dem Entfernen, wenn ein Add-on einer Tischgruppe auf 0 geht */
    try {
      var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var tisch = (cart.items || []).filter(function (it) { return it.key === key; })[0];
      var alt = Math.max(1, (tisch && tisch.quantity) || 1);
      /* nur ein Tisch nimmt seine Gruppe mit, ein Add-on aendert nur sich selbst */
      if (tisch && istTisch(tisch)) (cart.items || []).forEach(function (it) {
        if (it.key === key || istTisch(it)) return;
        if (!it.properties || it.properties._eh_konfig !== konfig) return;
        var jeTisch = Math.max(1, Math.round(it.quantity / alt));
        updates[it.key] = menge * jeTisch;
      });
      else if (tisch && menge === 0 && tisch.properties && tisch.properties._eh_konfig) vorher = cart;
    } catch (e) { /* ohne Warenkorbdaten nur den Tisch aendern */ }

    if (istWarenkorbSeite()) {
      try {
        var r = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!r.ok) throw new Error('update ' + r.status);
        await austragen(vorher, key, '');
        window.location.href = root + 'cart';
      } catch (e) { perSeite(key, menge); }
      return;
    }

    /* Drawer: wie Prestige mit gebuendelten Sections und cart:change */
    var lineItem = el.closest('line-item');
    try {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      if (lineItem) lineItem.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: menge } }));
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      var res = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sections.join(',') })
      });
      if (!res.ok) throw new Error('update ' + res.status);
      var neu = await res.json();
      var ohne = await austragen(vorher, key, sections.join(','));
      if (ohne && ohne.sections) neu = ohne;
      else if (ohne) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      var danach = (neu.items || []).filter(function (it) { return it.key === key; });
      if (lineItem) lineItem.dispatchEvent(new CustomEvent('line-item:change', { bubbles: true, detail: { quantity: danach.length ? danach[0].quantity : 0, cart: neu } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: neu } }));
    } catch (e) {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      perSeite(key, menge);
    }
  }

  function abfangen(e, el, key, menge) {
    if (!el || !key || isNaN(menge) || menge < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (laeuft) return;
    laeuft = true;
    aendern(el, key, menge).catch(function () { perSeite(key, menge); }).then(function () { laeuft = false; });
  }

  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('line-item-quantity[data-eh-konfig] a[href*="/cart/change"]') : null;
      if (!a) return;
      var u = new URL(a.href, location.href);
      abfangen(e, a.closest('line-item-quantity'), u.searchParams.get('id'), parseInt(u.searchParams.get('quantity'), 10));
    } catch (err) { /* normaler Prestige-Ablauf */ }
  }, true);

  document.addEventListener('change', function (e) {
    try {
      var inp = e.target && e.target.closest ? e.target.closest('line-item-quantity[data-eh-konfig] [data-line-key]') : null;
      if (!inp) return;
      abfangen(e, inp.closest('line-item-quantity'), inp.getAttribute('data-line-key'), parseInt(inp.value, 10));
    } catch (err) { /* normaler Prestige-Ablauf */ }
  }, true);
})();
